import { useAccountSwitcher } from '@/hooks/useAccountSwitcher';
import { useActingAsBannerStore } from '@/services/stores/actingAsBannerStore';

/**
 * Whether the acting-as banner is on screen: impersonating and not hidden.
 *
 * Layout code that makes room for the banner (headers, the chat composer) reads
 * this rather than `isActingAsOther`, since a hidden banner takes no space.
 */
export function useIsActingAsBannerVisible() {
  const { isActingAsOther, actAsUserId } = useAccountSwitcher();

  const hiddenForUserId = useActingAsBannerStore((state) => state.hiddenForUserId);

  return isActingAsOther && hiddenForUserId !== actAsUserId;
}
